<template>
  <v-menu v-model="open" offset-y left nudge-bottom="6" min-width="288" max-width="320">
    <template v-slot:activator="{ on, attrs }">
      <button type="button" class="tools-menu__trigger" :class="{ 'tools-menu__trigger--open': open }" v-bind="attrs" v-on="on" title="Outils" aria-label="Outils" aria-haspopup="menu" :aria-expanded="String(open)">
        <v-icon size="20">apps</v-icon>
        <span class="d-none d-md-inline">Outils</span>
        <v-icon size="18" class="tools-menu__chevron d-none d-md-inline-flex" :class="{ 'tools-menu__chevron--open': open }">expand_more</v-icon>
      </button>
    </template>
    <div class="tools-menu">
      <div v-for="group in GROUPS" :key="group.label" class="tools-menu__group">
        <div class="tools-menu__label">{{ group.label }}</div>
        <a v-for="tool in group.tools" :key="tool.href" :href="tool.href" target="_blank" rel="noopener" class="tools-menu__item">
          <span class="tools-menu__icon"><v-icon size="18">{{ tool.icon }}</v-icon></span>
          <span class="tools-menu__text">
            <span class="tools-menu__title">{{ tool.label }}</span>
            <span class="tools-menu__sub">{{ tool.description }}</span>
          </span>
          <v-icon size="16" class="tools-menu__ext">open_in_new</v-icon>
        </a>
      </div>
    </div>
  </v-menu>
</template>

<script>
  // Liens vers les outils externes de l'équipe, groupés par usage, dans la barre du haut
  const GROUPS = [
    {
      label: 'Supervision',
      tools: [
        { label: 'Grafana', description: 'Tableaux de bord et métriques', icon: 'multiline_chart', href: 'https://grafana.hublot.io' },
        { label: 'SigNoz', description: 'Logs et traces des services', icon: 'description', href: 'https://signoz.hublot.io' },
        { label: 'Uptime Kuma', description: 'Disponibilité des services', icon: 'monitor_heart', href: 'https://uptime.hublot.io' }
      ]
    },
    {
      label: 'Terrain',
      tools: [
        { label: 'Carte des magasins', description: 'map.hublot.io', icon: 'public', href: 'https://map.hublot.io' },
        { label: 'Samsung Knox', description: 'Console MDM des tablettes', icon: 'phonelink_setup', href: 'https://eu08.manage.samsungknox.com/emm/admin/secured/emm_main.do#dashboardHome@1757071555' }
      ]
    }
  ]

  export default {
    name: 'ToolsMenu',
    data () {
      return { GROUPS, open: false }
    }
  }
</script>

<style lang="scss" scoped>
.tools-menu__trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: var(--control);
  padding: 0 var(--space-2);
  border: 0;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--ink);
  font: inherit;
  font-weight: 500;
  cursor: pointer;

  .v-icon { color: var(--ink-muted); }
  &:focus-visible { outline: 2px solid var(--focus-ring); outline-offset: 2px; }
  // Posé sur la barre teintée métier : le survol suit la même teinte que la barre latérale
  &--open { background: var(--nav-hover); }
  @media (hover: hover) and (pointer: fine) {
    &:hover { background: var(--nav-hover); }
  }
}
.tools-menu__chevron.v-icon {
  transition: transform 160ms var(--hb-ease-out);
  &--open { transform: rotate(180deg); }
}

.tools-menu {
  background: var(--surface-raised);
  padding: var(--space-1) 0;
}
.tools-menu__group + .tools-menu__group { border-top: 1px solid var(--line); margin-top: var(--space-1); padding-top: var(--space-1); }
.tools-menu__label {
  font: var(--text-label);
  color: var(--ink-muted);
  padding: var(--space-2) var(--space-3) var(--space-1);
}
.tools-menu__item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 6px var(--space-3);
  color: var(--ink);
  text-decoration: none;

  &:focus-visible { outline: 2px solid var(--focus-ring); outline-offset: -2px; }
  @media (hover: hover) and (pointer: fine) {
    &:hover { background: var(--surface-sunken); }
    &:hover .tools-menu__ext { opacity: 1; }
  }
}
.tools-menu__icon {
  width: 28px;
  height: 28px;
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  background: var(--surface-sunken);
  .v-icon { color: var(--ink-muted); }
}
.tools-menu__text { display: flex; flex-direction: column; min-width: 0; flex: 1; }
.tools-menu__title { font-weight: 500; line-height: 18px; }
.tools-menu__sub { font: var(--text-small); color: var(--ink-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tools-menu__ext.v-icon { color: var(--ink-faint); opacity: 0; transition: opacity 120ms ease; }

@media (prefers-reduced-motion: reduce) {
  .tools-menu__chevron.v-icon, .tools-menu__ext.v-icon { transition: none; }
}
</style>
